/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import Modal from 'react-modal'
import Toggle from 'react-toggle';
import { v4 as uuid } from 'uuid';
import 'react-toggle/style.css';
import { ExpectedDateGenerator } from '../../redux/helper/DateConverter';
import CategoryToolTip from '../CategoryToolTip';
import ThreeDotsLoader from '../LoadingDots';
import { distributorService } from '../../service/distributor.service';
import ConfirmPopUp from './ConfirmPopUp';

export default function SplitAddress({setSplitPopup, setSplitModal, splitModal, splitPopup, GetCartItems, setinitialrender }) {
    const prod = {...splitModal}
    const [confirmPopup, setconfirmPopup] = useState(false);
    const [loading, setloading] = useState(false);
    const [splitButtonDisable, setsplitButtonDisable] = useState(true);
    const [splittedItemArray, setSplittedItemArray] = useState([{quantity: prod?.quantity || 1, item_id: prod?.item_id, error: false, discount_applied: 0}])

    const handleAddSplit = () => {
        const tempItem = {quantity: 0, item_id: uuid(), error: true, discount_applied: 0}
        const tempArray = [...splittedItemArray, tempItem]
        setSplittedItemArray([... tempArray]);
        handleUpdateState(tempArray)
    };

    const handleDeleteSplit = (index) => {
        if(splittedItemArray.length > 1){
            const tempArray = [... splittedItemArray]
            tempArray.splice(index, 1)
            setSplittedItemArray([...tempArray]);
            handleUpdateState([...tempArray])
        }
    };

    const handleChange = (event, index) => {
        const inputVal = event.target.value;
        const tempArray = [... splittedItemArray]
        // Regular expression to match only numbers (integer or decimal)
        const numberRegex = /^\d*\.?\d*$/;
        const packagingSize = prod.PACKING_SIZE || 1
        const minimumOrderQuantity = prod.MINIMUM_ORDER_QUANTITY || 1
    
        // Check if the input matches the number regex or if it's an empty string
        if (numberRegex.test(inputVal) || inputVal === '') {
            // Convert input value to a floating-point number
            const valueAsFloat = inputVal === '' ? 0 : parseFloat(inputVal);
      
            // Calculate the remainder when dividing the value by the packaging size
            const remainder = valueAsFloat % packagingSize;
      
            // Check if the value is greater than or equal to the minimum order quantity
            // and if it's a multiple of the packaging size
            if (valueAsFloat >= minimumOrderQuantity && remainder === 0) {
                tempArray[index].error = false
            }
            else tempArray[index].error = true

        } else tempArray[index].error = true
        tempArray[index].quantity = event.target.value;
        setSplittedItemArray([... tempArray])
        handleUpdateState(tempArray)
    };

    const handleQuantityChange = (action, index) => {
        // Step by the packaging size, but not below the minimum order quantity
        const tempArray = [... splittedItemArray]
        const packagingSize = Number(prod.PACKING_SIZE || 1);
        // Work in whole pack steps to avoid floating point modulo errors (e.g. 1.05 % 0.01)
        const steps = Number(tempArray[index].quantity) / packagingSize;
        const nextSteps = action === '+' ? Math.floor(steps + 1e-6) + 1 : Math.ceil(steps - 1e-6) - 1;
        const next = Number((nextSteps * packagingSize).toFixed(4));
        tempArray[index].quantity = Math.max(Number(prod.MINIMUM_ORDER_QUANTITY || 1), next)
        tempArray[index].error = false;
        setSplittedItemArray([... tempArray]);
        handleUpdateState(tempArray)
    };

    

    // Function to calculate the sum of quantities
    

    // Update the state based on conditions
    const handleUpdateState = (tempArray) => {
        const allErrorsAreFalse = tempArray.every((item) => !item.error);
        const sumOfQuantities = tempArray.reduce(
            (accumulator, item) => accumulator + Number(item.quantity),
            0
        );
        if (allErrorsAreFalse && sumOfQuantities === Number(prod.quantity) && tempArray.length > 1) {
            // Do something if all elements have error as false and the sum of quantities is equal to total quantity
            setsplitButtonDisable(false)
        } else {
            // Do something else if the conditions are not met
            setsplitButtonDisable(true)
        }
    };
    
    const [hoverId, sethoverId] = useState('');
    const handleConfirm = async() => {
        setloading(true);
        const payload = []
        setinitialrender(0)
        for (let index = 0; index < splittedItemArray.length; index++) {
            const element = splittedItemArray[index];
            const tempCart = {... prod, ...element}
            payload.push(tempCart)

        }
        payload[0]['item_id'] = prod.item_id
        const res = await distributorService.SplitItem(payload);
        
        if(!res.error && res.data.success_status){
            setloading(false)
            GetCartItems();
            setconfirmPopup(false)
            setSplitPopup(false)
        }else{
            setloading(false)
        }
    };
    return (
        <><Modal isOpen={splitPopup}>
            <div className="modal-dialog modal-dialog-centered relative lg:min-w-fit px-3 mx-auto pointer-events-none">
                <div className="modal-content border-none shadow-lg relative flex flex-col pointer-events-auto w-full bg-white bg-clip-padding rounded-md outline-none text-current md:px-[32px] sm:px-5 px-3.5 sm:pt-[32px] pt-5 sm:pb-6 pb-5">
                    <div className="modal-header flex flex-shrink-0 items-center justify-center rounded-t-md relative">
                        <h5 className="sm:text-xl text-lg font-semibold leading-normal text-[#090406]" id="exampleModalScrollableLabel">
                            Split Product
                        </h5>
                        <button
                            onClick={() => {
                                setSplitModal('');
                                setSplitPopup(false);
                            } }
                            type="button"
                            className="absolute top-0 right-0"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        >
                            <img src="/images/Icon-ionic-ios-close.svg" alt="" />
                        </button>
                    </div>
                    <div className="relative rounded-[10px] bg-ffffff w-full flex flex-row p-[1.19rem] box-border items-start justify-start mix-blend-normal text-center text-[1.25rem] text-gray font-source-sans-pro">
                        <div className="flex flex-col items-center justify-start gap-[0.78rem]">
                            <div className="flex flex-col items-center justify-start gap-[0.38rem]">
                                <div className="flex flex-col items-center justify-start">
                                    <b className="relative leading-[1.56rem] mix-blend-normal">{prod?.MODEL_DESCRIPTION || `${prod?.DESCRIPTION.length > 20 ? `${prod.DESCRIPTION.slice(0, 20)}...` : `${prod.DESCRIPTION}`}`}</b>
                                    <div className="relative text-[0.75rem] leading-[1.19rem] text-color1 whitespace-pre-wrap mix-blend-normal">
                                        <p className="m-0">
                                            Product Code:
                                            {' '}
                                            {prod?.CONCATENATED_SEGMENTS}     |     AWS Classification:
                                            {' '}
                                            {prod?.AWS_CLASSIFICATION}</p>
                                        <p className="m-0">MOQ: {prod?.MINIMUM_ORDER_QUANTITY || 1} {prod?.PRIMARY_UOM_CODE}    |       Standard Pack Size: {prod?.PACKING_SIZE || 1} {prod?.PRIMARY_UOM_CODE}</p>
                                        <p className="m-0">{prod?.DESCRIPTION}</p>
                                    </div>
                                </div>
                                <div className="relative text-[0.94rem] leading-[1.25rem] text-color mix-blend-normal">Total Quantity: {prod?.quantity} {prod?.PRIMARY_UOM_CODE}</div>
                            </div>
                            <div className="scroller-container" style={{ maxHeight:'300px', overflowY: 'scroll'}}>
                                <div className="flex flex-col items-start justify-start gap-[0.44rem] text-[1rem] text-color1">
                                    {splittedItemArray && splittedItemArray.map((item, index) => (
                                        <div key={`${item.item_id}`} className="relative rounded-lg bg-[#F5F5FA] w-full overflow-hidden flex flex-col py-[0.75rem] px-[1.19rem] box-border items-start justify-start gap-[0.38rem] text-center text-[1rem] text-color font-source-sans-pro">
                                            <div className="flex flex-row items-center justify-start gap-[4.19rem]">
                                                <div className="relative text-[#555259] text-[1rem] leading-[1.25rem] font-semibold font-source-sans-pro text-color text-center mix-blend-normal">Split {index + 1}</div>
                                                <div className="relative  text-[#555259] text-[0.69rem] leading-[0.81rem] font-semibold font-source-sans-pro text-color text-left mix-blend-normal">Set Quantity</div>
                                                <div className="ml-4 2xl:w-[30%]">
                                                    {/* <p className="text-xs3 font-semibold text-[#808285] text-center mr-[17px] ">Set Quantity</p> */}
                                                    <div className={`flex items-stretch w-fit h-[36px] rounded-md border bg-white overflow-hidden transition-colors ${item.error === true ? 'border-[#ED1C24]' : 'border-[#CBCBCB] focus-within:border-[#555259]'}`}>
                                                        <button
                                                            onClick={() => handleQuantityChange('-', index)}
                                                            disabled={(Math.ceil(Number(item.quantity) / Number(prod?.PACKING_SIZE || 1) - 1e-6) - 1) * Number(prod?.PACKING_SIZE || 1) < Number(prod?.MINIMUM_ORDER_QUANTITY || 1) - 1e-6}
                                                            aria-label="Decrease quantity"
                                                            title="Decrease quantity"
                                                            type="button" className="w-[36px] flex items-center justify-center bg-[#E4E4EA] text-[#555259] border-r border-[#CBCBCB] hover:bg-[#555259] hover:text-white active:bg-[#3d3b40] active:text-white transition-colors disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-[#E4E4EA] disabled:hover:text-[#555259]">
                                                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M2 6h8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
                                                        </button>
                                                        <div className="flex items-center px-2 gap-1">
                                                            <input
                                                                type="text"
                                                                inputMode="decimal"
                                                                aria-label="Quantity"
                                                                onChange={(e) => handleChange(e, index)}
                                                                value={item.quantity}
                                                                onKeyDown={(e) => ['ArrowUp', 'ArrowDown'].includes(e.key) && e.preventDefault()}
                                                                className="w-[72px] h-full border-0 outline-none focus:outline-none focus:ring-0 shadow-none bg-transparent text-center sm:text-[15px] text-sm font-semibold text-[#090406]" />
                                                            <span className="text-sm font-semibold text-[#808285]">{prod?.PRIMARY_UOM_CODE}</span>
                                                        </div>
                                                        <button
                                                            onClick={() => handleQuantityChange('+', index)}
                                                            aria-label="Increase quantity"
                                                            title="Increase quantity"
                                                            type="button" className="w-[36px] flex items-center justify-center bg-[#E4E4EA] text-[#555259] border-l border-[#CBCBCB] hover:bg-[#555259] hover:text-white active:bg-[#3d3b40] active:text-white transition-colors">
                                                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M2 6h8M6 2v8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div
                                                    className='justify-end cursor-pointer'
                                                    onClick={() => handleDeleteSplit(index)}
                                                >
                                                    <img className="relative w-[1rem] h-[1rem]" alt="" src="/images/delete-item.svg" />
                                                </div>
                                            </div>
                                            <div className="flex flex-row items-center justify-start gap-[0.25rem] text-left text-[0.63rem] text-ed1c24">
                                                <img className="relative w-[0.56rem] h-[0.56rem] mix-blend-normal" alt="" src="images/info_icon1.svg" />
                                                <div className={`relative leading-[0.81rem] mix-blend-normal ${item.error === true ? 'text-[#ed1c24]' : ''}`}>{`Quantity is based on the MOQ and Standard Pack Size `}</div>
                                            </div>
                                        </div>
                                    ))}                                 
                                </div>                        
                            </div>
                            <div
                                className="relative text-[0.75rem] leading-[1.25rem] font-semibold mix-blend-normal cursor-pointer self-start"
                                onClick={handleAddSplit}>+ Add Split
                            </div>
                            <div className="flex flex-row items-start justify-start gap-[3.56rem] text-[0.88rem] text-color">
                                <button
                                    onClick={() => {
                                        setSplitModal('');
                                        setSplitPopup(false);
                                    } }
                                    type="button"
                                    className=" flex justify-center items-center w-[8.39rem] h-[2.5rem] mix-blend-normal sm:py-3.5 py-2 rounded-lg bg-[#FFFFFF] sm:text-lg text-base font-semibold text-[#555259] rounded border-2 border-[#808285] cursor-pointer" data-bs-dismiss="modal" aria-label="Close">
                                    Cancel
                                </button>
                                <button
                                    onClick={() => !splitButtonDisable && setconfirmPopup(true)}
                                    type="button"
                                    disabled={splitButtonDisable}
                                    className={`flex justify-center items-center w-[17.75rem] h-[2.5rem] mix-blend-normal sm:py-3.5 py-2 rounded-lg ${splitButtonDisable? 'bg-[#A5A5A5] border border-[#808285]': 'bg-[#555259]'} sm:text-lg text-base font-semibold text-[#FFFFFF] cursor-pointer`} data-bs-dismiss="modal" aria-label="Close">
                                    Apply split
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal><ConfirmPopUp confirmPopup ={confirmPopup}
            setconfirmPopup={setconfirmPopup}
            loading={loading}
            handleConfirm={handleConfirm} /></> 
    )
}
